module.exports = __webpack_public_path__ + "img/img (13).c91514e1.jpg";